export default __webpack_public_path__ + "static/media/bedroom.82e20b4b.webp";